// Pastille « église de rattachement », affichée dans les listes en vue globale
// (RCC-SEC-001) — une donnée sans église est signalée comme « Non classé ».
export default function ChurchBadge({ name }) {
  if (!name) {
    return (
      <span style={{ display: 'inline-block', padding: '2px 9px', borderRadius: '999px', fontSize: '0.75rem', fontWeight: 700, background: '#fef3c7', color: '#92400e', whiteSpace: 'nowrap' }}>
        Non classé
      </span>
    );
  }
  return (
    <span style={{ display: 'inline-block', padding: '2px 9px', borderRadius: '999px', fontSize: '0.75rem', fontWeight: 700, background: '#eef2ff', color: '#3730a3', whiteSpace: 'nowrap' }}>
      {name}
    </span>
  );
}
